/**
 * State selector for the Sales Territory Finder.
 *
 * Reads the pre-rendered rep data island on init and exposes the chosen state's
 * regions, each holding the companies that serve it. A state's regions arrive
 * already ordered by PHP ( "Statewide" first, then alphabetical ), so the
 * component only tracks which one is open.
 *
 * Regions render as an accordion, opening the first one whenever a new state is
 * picked. A state served by a single region has nothing to toggle between, so
 * `isAccordion` reports false and the template renders it as a plain block.
 */

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'salesTerritoryFinder', () => ({

		selectedState: '',
		repsByState  : {},
		stateNames   : {},

		// Index of the open region within the selected state. Reset to the top
		// region by the `selectedState` watcher below.
		activeRegion: 0,

		init( json ) {
			try {
				this.repsByState = JSON.parse( json );
			} catch {
				this.repsByState = {};
			}

			this.$el.querySelectorAll( 'option[value]' ).forEach( ( option ) => {
				if ( option.value ) {
					this.stateNames[ option.value ] = option.textContent;
				}
			});

			// Loading a state's data always opens its top-most region, rather
			// than carrying the previous state's open index over to it.
			this.$watch( 'selectedState', () => {
				this.activeRegion = 0;
			});
		},

		get currentState() {
			return ! ! this.selectedState;
		},

		get currentStateName() {
			return this.stateNames[ this.selectedState ] || '';
		},

		get currentRegions() {
			return this.repsByState[ this.selectedState ] || [];
		},

		// A lone region is shown expanded and without a trigger, so there is no
		// collapsed state a visitor could get stuck in.
		get isAccordion() {
			return 1 < this.currentRegions.length;
		},

		isOpen( index ) {
			return ! this.isAccordion || this.activeRegion === index;
		},

		toggle( index ) {
			this.activeRegion = this.activeRegion === index ? null : index;
		},
	}) );
});
